module.exports = __webpack_public_path__ + "static/media/repeat-1.a520a5e8.svg";